<template>
  <a :href="'case_study/' + routerLinkCompanyName" >
    <article class="case-study-article">
      <div class="case-study-section-wrapper">
        <section class="upper-section" :class="{'upper-section-even': idx % 2 === 1}">
          <div class="conmany-info-wrapper">
            <div class="conmany-info-content" :class="{'conmany-info-content-odd': idx % 2 === 0, 'conmany-info-content-even': idx % 2 === 1}">
              <h3 class="case-study-title" v-html="title"></h3>
              <div class="company-name-container">
                <p class="company-name">{{companyName}}</p>
                <div class="company-logo-wrapper">
                  <img class="company-logo" :src="companyLogo" :alt="`${companyName}ロゴ`">
                </div>
              </div>
            </div>
          </div>
          <div class="company-img-wrapper">
            <img class="company-img" :src="img" :alt="`${companyName}写真`">
          </div>
        </section>
        <section class="under-section">
          <p>{{detail}}</p>
        </section>
      </div>
    </article>
  </a>
</template>

<script>
export default {
  name: 'CaseStudyArticle',
  props: {
    idx: {
      type: Number,
      required: false,
      default: 0
    },
    img: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    companyName: {
      type: String,
      required: false,
      default: ''
    },
    companyLogo: {
      type: String,
      required: false,
      default: ''
    },
    detail: {
      type: String,
      required: false,
      default: ''
    },
    routerLinkCompanyName: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
$upper-section-block-width: 440px;
$upper-section-block-height: 240px;
$under-section-width: $upper-section-block-width * 2;

article {
  color: #333333;
  cursor: pointer;
  transition: 0.5s;
}
article:hover {
  opacity: 0.8;
  transform: scale(1.05);
}
.case-study-article {
  display: flex;
  justify-content: center;
  margin: 0 40px 80px;
  transition: 0.5s;
}
.company-img-wrapper {
  max-width: $upper-section-block-width;
  width: 100%;
  height: $upper-section-block-height;
}
.company-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border: 1px solid #dbdbdb;
  border-radius: 4px;
}
.upper-section {
  display: flex;
}
.conmany-info-wrapper {
  max-width: $upper-section-block-width;
  width: 100%;
  display: flex;
  align-items: center;
}
.company-name-container {
  margin-top: 24px;
}
.company-name {
  margin-right: 8px;
  font-weight: bold;
}
.conmany-info-content-odd {
  padding-right: 16px;
}
.conmany-info-content-even {
  padding-left: 16px;
}
.company-logo-wrapper {
  margin-top: 8px;
}
.company-logo {
  height: 24px;
}
.under-section {
  margin-top: 32px;
  max-width: $under-section-width;
  width: 100%;
  P {
    font-size: 14px;
    line-height: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
}
.upper-section-even {
  flex-direction: row-reverse;
}

@media screen and (max-width: 1024px) {
  $upper-section-block-width: 400px;
  $upper-section-block-height: 200px;
  $under-section-width: $upper-section-block-width * 2;

  .company-img-wrapper {
    max-width: $upper-section-block-width;
    height: $upper-section-block-height;
  }
  .conmany-info-wrapper {
    max-width: $upper-section-block-width;
  }
  .under-section {
    max-width: $under-section-width;
  }
}
@media screen and (max-width: 896px) {
  $upper-section-block-width: 400px;
  $under-section-width: $upper-section-block-width;

  .upper-section {
    flex-direction:column;
  }
  .conmany-info-content-odd, .conmany-info-content-even {
    padding: 0;
  }
  .case-study-article {
    margin: 0 0 40px 0;
  }
  .company-name-container {
    margin: 16px 0;
  }
  .under-section {
    max-width: $under-section-width;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/atoms/CaseStudyArticle.vue